import { useFlags } from 'launchdarkly-react-client-sdk';
import { NavLink, useLocation } from 'react-router-dom';
import PageContainer from '../shared-components/PageContainer/PageContainer';
import * as styles from './MyAccountNav.module.css';

const MyAccountNav = () => {
  const location = useLocation();
  // Get base URL from pathname (removes trailing slash and any sub-routes)
  const baseUrl = '/my-account';
  const flags = useFlags();
  const { myAccountOrderHistory: myAccountOrderHistoryFF, rateAndReview: rateAndReviewFF } = flags;
  const ordersPathname = myAccountOrderHistoryFF ? 'orders' : 'invoice-history';

  return (
    <div className={styles.navContainer}>
      <PageContainer>
        <div className={styles.nav}>
          <NavLink
            to={baseUrl}
            className={({ isActive }) =>
              `${styles.tab} ${isActive && location.pathname === baseUrl ? styles.active : ''}`
            }
            end
          >
            Account Details
          </NavLink>
          <NavLink
            to={`${baseUrl}/${ordersPathname}`}
            className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
          >
            {myAccountOrderHistoryFF ? 'Orders' : 'Invoice History'}
          </NavLink>
          {rateAndReviewFF && (
            <NavLink
              data-testid="rate-and-review-tab"
              to={`${baseUrl}/rate-and-review`}
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
            >
              Rate & Review
            </NavLink>
          )}
          <NavLink
            to={`${baseUrl}/personal-survey`}
            className={({ isActive }) => `${styles.tab} ${isActive ? styles.active : ''}`}
          >
            Personal Survey
          </NavLink>
        </div>
      </PageContainer>
    </div>
  );
};

export default MyAccountNav;
